import { getLabelGraduacion, transponer } from './graduaciones.helper';
import { ERROR_ALTURA_FOCAL } from '../../modules/pel/model/constants/erroresSeleccionLente.constants';

export function formatearDatosGraduacion(datosGraduacion, trabajaCilindroPositivo = false) {
  const ojoDerechoOriginal = datosGraduacion.ojo_derecho;
  const ojoIzquierdoOriginal = datosGraduacion.ojo_izquierdo;
  const ojoDerecho = trabajaCilindroPositivo ? ojoDerechoOriginal : transponer(ojoDerechoOriginal);
  const ojoIzquierdo = trabajaCilindroPositivo ? ojoIzquierdoOriginal : transponer(ojoIzquierdoOriginal);
  const ojoDerechoFormateado = {
    ojo: 'derecho',
    label: getLabelGraduacion(ojoDerecho),
    ESFL: ojoDerecho.esfera_lejos,
    ESFC: ojoDerecho.esfera_cerca,
    CILL: ojoDerecho.cilindro_lejos,
    CILC: ojoDerecho.cilindro_cerca,
    AXISL: ojoDerecho.eje_lejos,
    AXISC: ojoDerecho.eje_cerca,
    ADD: ojoDerecho.adicion,
    DNPL: ojoDerecho.Dnp_lejos,
    AVSC: ojoDerecho.agudeza_visual_sin_correccion,
    AVCC: ojoDerecho.agudeza_visual_con_correccion,
    transposicion: ojoDerecho.transposicion ? ojoDerecho.transposicion : false,
  };
  const ojoIzquierdoFormateado = {
    ojo: 'izquierdo',
    label: getLabelGraduacion(ojoIzquierdo),
    ESFL: ojoIzquierdo.esfera_lejos,
    ESFC: ojoIzquierdo.esfera_cerca,
    CILL: ojoIzquierdo.cilindro_lejos,
    CILC: ojoIzquierdo.cilindro_cerca,
    AXISL: ojoIzquierdo.eje_lejos,
    AXISC: ojoIzquierdo.eje_cerca,
    ADD: ojoIzquierdo.adicion,
    DNPL: ojoIzquierdo.Dnp_lejos,
    AVSC: ojoIzquierdo.agudeza_visual_sin_correccion,
    AVCC: ojoIzquierdo.agudeza_visual_con_correccion,
    transposicion: ojoIzquierdo.transposicion ? ojoIzquierdo.transposicion : false,
  };
  if (trabajaCilindroPositivo) {
    ojoDerechoFormateado.label_original = getLabelGraduacion(ojoDerechoOriginal);
    ojoIzquierdoFormateado.label_original = getLabelGraduacion(ojoIzquierdoOriginal);
  }
  return { graduacionOjoIzquierdo: ojoIzquierdoFormateado, graduacionOjoDerecho: ojoDerechoFormateado };
}
export function formateaDatosMontura(montura, graduaciones) {
  let formaOma = montura.forma_oma_montura;
  let tipoMontura = null;
  let puente = null;
  let calibre = null;
  let diametroMinimo = null;
  let tieneFormaOma = false;
  if (formaOma) {
    formaOma = JSON.parse(formaOma);
    tipoMontura = formaOma.FTYP;
    puente = formaOma.BRGSIZ ? formaOma.BRGSIZ : formaOma.DBL;
    calibre = formaOma.EYESIZ ? formaOma.EYESIZ : formaOma.HBOX;
    tieneFormaOma = true;
  }
  const pupilarL = graduaciones.ojo_izquierdo.Dnp_lejos;
  const pupilarD = graduaciones.ojo_derecho.Dnp_lejos;
  if (calibre !== null && (pupilarL !== null || pupilarD !== null) && puente !== null) {
    const diametroMinimoL = (tipoMontura === 1) ? (2 * (parseFloat(calibre) - parseFloat(pupilarL) + 3) + parseFloat(puente)) : (2 * (parseFloat(calibre) - parseFloat(pupilarL) + 1.5) + parseFloat(puente));
    const diametroMinimoD = (tipoMontura === 1) ? (2 * (parseFloat(calibre) - parseFloat(pupilarD) + 3) + parseFloat(puente)) : (2 * (parseFloat(calibre) - parseFloat(pupilarD) + 1.5) + parseFloat(puente));
    diametroMinimo = (diametroMinimoD >= diametroMinimoL) ? diametroMinimoD : diametroMinimoL;
  }
  return {
    puente,
    calibre,
    tieneFormaOma,
    diametroMinimo,
  };
}
export function obtenerTextoPasillo(modoNoPel, pasillo) {
  const textoPasillo = pasillo.id === 1 && !modoNoPel ? 'NORMAL' : '';
  return pasillo.id === 2 && !modoNoPel ? 'SHORT' : textoPasillo;
}
export function obtenerDescripcionColor(modoNoPel, miColor, selectedGamaColor, gamasColoresOpciones, trabajaConColores, color = null) {
  let gamaColor = null;
  let nombreColoracion = '';
  let nombreColor = '';
  if (modoNoPel) {
    nombreColoracion = '';
    nombreColor = '';
  } else {
    gamaColor = (miColor !== undefined && miColor !== null) ? gamasColoresOpciones.find(e => e.id === miColor.gamaColor) : gamasColoresOpciones.find(e => e.id === selectedGamaColor.id);
    if (gamaColor) {
      nombreColoracion = gamaColor.id === 1 ? '' : ` ${gamaColor.gama_color}`;
      nombreColor = (!trabajaConColores || gamaColor.id === 1 || miColor.id === 1) ? '' : ` ${color !== null ? color.nombre : miColor.nombre}`;
    } else if (selectedGamaColor) {
      nombreColoracion = selectedGamaColor.id === 1 ? '' : ` ${selectedGamaColor.gama_color}`;
      nombreColor = (!trabajaConColores || selectedGamaColor.id === 1 || miColor.id === 1) ? '' : ` ${color !== null ? color.nombre : miColor.nombre}`;
    } else {
      nombreColoracion = '';
      nombreColor = '';
    }
  }
  return { nombreColoracion, nombreColor };
}
export function obtenerDescripcionLenteCompletaSinSuplementos(modoNoPel, nombreCompleto, datosColor, pasillo) {
  const {
    miColor, gamaColor, gamasColoresOpciones, trabajaConColores,
  } = datosColor;
  const textoPasillo = obtenerTextoPasillo(modoNoPel, pasillo);
  const tieneColor = datosColor.color !== undefined && datosColor.color !== null;
  const { nombreColoracion, nombreColor } = obtenerDescripcionColor(modoNoPel, miColor, gamaColor, gamasColoresOpciones, trabajaConColores, tieneColor ? datosColor.color : null);
  return `${nombreCompleto}${nombreColoracion}${nombreColor} ${textoPasillo}`;
}
export function comprobarDatosSeleccionLente(pel, usaVentanaTrazadora, trabajaConColores, alturafocalObligatoria) {
  const {
    filtrador: {
      lentes, selecciones: {
        graduacion,
      },
    },
  } = pel;
  const lentesKeys = Object.keys(lentes);
  const lenteSeleccionadaKey = lentesKeys.find(lenteKey => lentes[lenteKey].isSelected);
  const lenteSeleccionada = lentes[lenteSeleccionadaKey];
  const graduacionSeleccionada = { valor: graduacion.valor };
  if (graduacion.izquierdo && graduacion.izquierdo.isSelected) {
    graduacionSeleccionada.izquierdo = graduacion.izquierdo;
  }
  if (graduacion.derecho && graduacion.derecho.isSelected) {
    graduacionSeleccionada.derecho = graduacion.derecho;
  }
  if (alturafocalObligatoria && graduacionSeleccionada.derecho && graduacionSeleccionada.izquierdo && (!lenteSeleccionada.alturaFocal || (!lenteSeleccionada.alturaFocal.D && !lenteSeleccionada.alturaFocal.I))) {
    return { lenteKey: lenteSeleccionadaKey, element: ERROR_ALTURA_FOCAL, message: 'Altura focal obligatoria' };
  }
  if (alturafocalObligatoria && graduacionSeleccionada.izquierdo && (!lenteSeleccionada.alturaFocal || (!lenteSeleccionada.alturaFocal.I))) {
    return {
      lenteKey: lenteSeleccionadaKey, element: ERROR_ALTURA_FOCAL, errorData: { ojo: 'izquierdo' }, message: 'Altura focal izquierda obligatoria',
    };
  }
  if (alturafocalObligatoria && graduacionSeleccionada.derecho && (!lenteSeleccionada.alturaFocal || (!lenteSeleccionada.alturaFocal.D))) {
    return {
      lenteKey: lenteSeleccionadaKey, element: ERROR_ALTURA_FOCAL, errorData: { ojo: 'derecho' }, message: 'Altura focal derecha obligatoria',
    };
  }
  return null;
}
export function formatearDatosSeleccionPel(pel, usaVentanaTrazadora, trabajaConColores) {
  const {
    filtrador: {
      fueraDeNorma,
      lentes, selecciones: {
        graduacion, miFabricante, focos, pasillos, miColor, categorias, montura, colores,
      }, formulario: { colores: gamasColoresFormulario },
    }, modoNoPel,
  } = pel;
  const lentesKeys = Object.keys(lentes);
  const lenteSeleccionadaKey = lentesKeys.filter(lenteKey => lentes[lenteKey].isSelected);
  const lenteSeleccionada = lentes[lenteSeleccionadaKey];
  const graduacionSeleccionada = { valor: graduacion.valor };
  if (graduacion.izquierdo && graduacion.izquierdo.isSelected) {
    graduacionSeleccionada.izquierdo = graduacion.izquierdo;
  }
  if (graduacion.derecho && graduacion.derecho.isSelected) {
    graduacionSeleccionada.derecho = graduacion.derecho;
  }
  lenteSeleccionada.tratamiento = lenteSeleccionada.tratamientos.filter(e => e.isSelected);
  lenteSeleccionada.colores = lenteSeleccionada.colores.filter(e => e.isSelected);
  const color = lenteSeleccionada.colores.length > 0 ? { ...lenteSeleccionada.colores[0] } : null;
  const selectedPasillo = pasillos.find(pasillo => pasillo.isSelected);
  const { esMiCatalogo } = lenteSeleccionada;
  const gamasColoresOpciones = gamasColoresFormulario && gamasColoresFormulario.opciones ? gamasColoresFormulario.opciones : null;
  const tratamiento = lenteSeleccionada.tratamiento[0];

  const descripcionCompletaSinSuplementos = obtenerDescripcionLenteCompletaSinSuplementos(modoNoPel,
    lenteSeleccionada.tGamaDescripcion || lenteSeleccionada.nombreCompleto, {
      miColor, gamaColor: colores, gamasColoresOpciones, color, trabajaConColores,
    }, selectedPasillo);
  const descripcionCompletaConTratamientoSinSuplementos = modoNoPel || tratamiento.id === 1
    ? descripcionCompletaSinSuplementos : `${descripcionCompletaSinSuplementos} ${tratamiento.nombre}`;

  return {
    lente: lenteSeleccionada,
    promoPropiedadId: lenteSeleccionada.promoPropiedadId,
    fueraDeNorma,
    descripcionCompletaConTratamientoSinSuplementos,
    graduacion: graduacionSeleccionada,
    miFabricante,
    foco: focos,
    pasillo: selectedPasillo,
    miColor,
    categoria: categorias,
    montura,
    esMiCatalogo,
    modoNoPel,
    usaVentanaTrazadora,
  };
}
export function obtenerDescripcionYPreciosSuplementos(esMiCatalogo, suplementos) {
  let precioSuplementos = 0;
  let costoSuplementos = 0;
  let descripcionSuplementos = '';
  for (let i = 0; i < suplementos.length; i += 1) {
    if (!esMiCatalogo || (!suplementos[i].incluidoMiCatalogo)) {
      precioSuplementos += parseFloat(suplementos[i].pvp);
      costoSuplementos += parseFloat(suplementos[i].pvo);
    }
    descripcionSuplementos += i === 0 ? suplementos[i].suplemento.descripcion : ` + ${suplementos[i].suplemento.descripcion}`;
  }
  return { descripcionSuplementos, precioSuplementos, costoSuplementos };
}
export function formatearDatosLenteEncargosPel(params, { datos: suplementos }) {
  const lentes = [];
  const {
    lente,
    descripcionCompletaConTratamientoSinSuplementos,
    graduacion,
    miFabricante,
    montura,
    foco,
    pasillo,
    esMiCatalogo,
  } = params;
  const proveedor = miFabricante ? miFabricante.proveedor : lente.proveedor.corto;
  const tarifaId = miFabricante ? miFabricante.tarifaId : null;
  const {
    idGama,
    indice,
    indiceId,
    lenteId,
    material,
    nombreCompleto,
    nombreLente,
    tGamaCodigo,
    tGamaDescripcion,
    tGamaId,
  } = lente;
  const diametros = { ...lente.diametrosSeleccionados };
  const tratamiento = { ...lente.tratamiento[0] };
  const color = lente.colores.length > 0 ? { ...lente.colores[0] } : null;
  const precio_oi = tratamiento.precio_oi ? tratamiento.precio_oi : tratamiento.precio;
  const costo_oi = tratamiento.costo_oi ? tratamiento.costo_oi : tratamiento.costo;
  let precioSinSuplementos = 0;
  let costoSinSuplementos = 0;
  const {
    descripcionSuplementos,
    precioSuplementos, costoSuplementos,
  } = obtenerDescripcionYPreciosSuplementos(esMiCatalogo, suplementos);

  let descripcionCompleta = descripcionSuplementos === ''
    ? descripcionCompletaConTratamientoSinSuplementos : `${descripcionCompletaConTratamientoSinSuplementos} + ${descripcionSuplementos}`;
  descripcionCompleta = descripcionCompleta.toUpperCase();
  if (graduacion.derecho && graduacion.derecho.isSelected) {
    precioSinSuplementos = esMiCatalogo ? parseFloat(tratamiento.precio) : parseFloat(tratamiento.precio) - parseFloat(tratamiento.precioTratamiento);
    costoSinSuplementos = esMiCatalogo ? parseFloat(tratamiento.costo) : parseFloat(tratamiento.costo) - parseFloat(tratamiento.costoTratamiento);
    lentes.push({
      catalogoId: tratamiento.catalogoId,
      esRX: tratamiento.esRX,
      foco: {
        id: foco.id, vision: foco.modo, codigo: lente.foco.id, nombre: foco.nombre,
      },
      idGama,
      indice,
      indiceId,
      lenteId,
      material,
      nombreCompleto,
      descripcionCompleta,
      nombreLente,
      tGamaCodigo,
      tGamaDescripcion,
      tGamaId,
      ojo: 'derecho',
      proveedor,
      tarifaId,
      diametro: diametros.D,
      datosMontura: montura,
      suplementos,
      color,
      tratamiento,
      pasillo,
      precioSinSuplementos,
      precio: precioSinSuplementos + precioSuplementos,
      costoSinSuplementos,
      costo: costoSinSuplementos + costoSuplementos,
      alturaFocal: (lente.alturaFocal && lente.alturaFocal.D) ? lente.alturaFocal.D : null,
    });
  }
  if (graduacion.izquierdo && graduacion.izquierdo.isSelected) {
    precioSinSuplementos = esMiCatalogo ? parseFloat(precio_oi) : parseFloat(precio_oi) - parseFloat(tratamiento.precioTratamiento);
    costoSinSuplementos = esMiCatalogo ? parseFloat(costo_oi) : parseFloat(costo_oi) - parseFloat(tratamiento.costoTratamiento);
    lentes.push({
      catalogoId: tratamiento.catalogoId,
      esRX: tratamiento.esRX,
      foco: {
        id: foco.id, vision: foco.modo, codigo: lente.foco.id, nombre: foco.nombre,
      },
      idGama,
      indice,
      indiceId,
      lenteId,
      material,
      nombreCompleto,
      nombreLente,
      descripcionCompleta,
      tGamaCodigo,
      tGamaDescripcion,
      tGamaId,
      ojo: 'izquierdo',
      proveedor,
      tarifaId,
      diametro: diametros.I,
      datosMontura: montura,
      suplementos,
      color,
      tratamiento,
      pasillo,
      precio: precioSinSuplementos + precioSuplementos,
      precioSinSuplementos,
      costoSinSuplementos,
      costo: costoSinSuplementos + costoSuplementos,
      alturaFocal: (lente.alturaFocal && lente.alturaFocal.I) ? lente.alturaFocal.I : null,
    });
  }
  return lentes;
}
export function formatearDatosLenteEncargosGW1(params) {
  const lentes = [];
  const {
    lente, graduacion, miFabricante: { proveedor, tarifaId }, foco, pasillo, miColor, categoria, montura,
  } = params;
  const datosPel = {
    foco: { ...foco, foto: undefined },
    pasillo: { ...pasillo, isSelected: undefined },
    miColor,
    categoria,
    diametroMinimoMontura: montura ? montura.diametroMinimo : null,
  };
  if (graduacion.derecho && graduacion.derecho.isSelected) {
    lentes.push({
      ...lente,
      ojo: 'derecho',
      proveedor,
      tarifaId,
      datosPel,
      descripcion: lente.tGamaDescripcion ? lente.tGamaDescripcion : lente.nombreCompleto,
      tratamientos: undefined,
      diametros: lente.diametrosSeleccionados,
      colores: undefined,
    });
  }
  if (graduacion.izquierdo && graduacion.izquierdo.isSelected) {
    lentes.push({
      ...lente,
      ojo: 'izquierdo',
      proveedor,
      tarifaId,
      datosPel,
      descripcion: lente.tGamaDescripcion ? lente.tGamaDescripcion : lente.nombreCompleto,
      tratamientos: undefined,
      diametros: lente.diametrosSeleccionados,
      colores: undefined,

    });
  }
  return lentes;
}

export function tieneRestriccionCliente(restriccion, { mismo_cliente }) {
  switch (restriccion.valor) {
    case 'mismo cliente':
      return !mismo_cliente;
    case 'clientes diferentes':
      return mismo_cliente;
    default:
      return true;
  }
}

